import { useMemo } from 'react';
import { SupportedLanguage } from 'src/common/contexts/language-context';

import { useGetUserQuery } from 'src/common/slices';

/* Fireship specific CTA */
export const useCampaignCta = (language?: SupportedLanguage, suffix = ''): [string, string] => {
  const { data: userDataResponse } = useGetUserQuery();

  return useMemo(() => {
    const formattedSuffix = suffix ? ` ${suffix}` : '';

    if (userDataResponse?.data?.user?.isPremium) {
      return [
        language === SupportedLanguage.FRENCH
          ? `Passer à l'annuel${formattedSuffix}`
          : `Switch to annual${formattedSuffix}`,
        '/manage-account/subscription',
      ];
    }
    return [
      language === SupportedLanguage.FRENCH ? `Abonnez-vous${formattedSuffix}` : `Subscribe Now${formattedSuffix}`,
      '/why-subscribe',
    ];
  }, [userDataResponse, language, suffix]);
};
